var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{style:(_vm.style),attrs:{"width":_vm.image.width,"height":_vm.image.height}})}
var staticRenderFns = []

export { render, staticRenderFns }